import ListItem from "@mui/material/ListItem";
import { styled as muiStyled } from "@mui/material/styles";
import styled from "styled-components";

import ColormapInterface from "shared-types/colormapinterface";
import { fontSize, borderRadius, getSpacing } from "stylesheetB2b";

interface Props {
  $on: boolean;
}

export const LastSongContainer = styled.div<{
  $on: boolean;
  colors: ColormapInterface;
}>`
  display: ${(props: Props) => (props.$on ? "flex" : "none")};
  width: 100%;
`;

export const LastSongContainerHeader = styled.div`
  min-height: ${getSpacing(6)};
  font-weight: bold;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  font-size: ${fontSize.small};
`;

export const LastSongItem = muiStyled(ListItem)<{ colors: ColormapInterface }>(
  ({ colors }) => ({
    borderRadius: borderRadius.XLarge,
    backgroundColor: colors.waitingListSongBackground,
    width: "100%",
    padding: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "normal",
    fontSize: fontSize.medium,
    lineHeight: "19,92px",
    "&:hover": {
      backgroundColor: colors.waitingListSongBackground,
    },
  }),
);
